import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MapPin } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export const QuickCheckInButton: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <Button
      onClick={() => navigate('/checkin')}
      className="w-full h-20 text-lg font-semibold bg-gradient-to-r from-primary to-[hsl(var(--primary)/0.8)] hover:opacity-90 hover:scale-105 transition-all duration-200 shadow-lg animate-pulse-glow"
      size="lg"
    >
      <MapPin className="w-6 h-6 mr-2" />
      {t('checkIn')}
    </Button>
  );
};
